import React from "react";
import { withStyles } from '@mui/styles';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Cookies from 'universal-cookie';

// Include our own codebase
import LogonScreen from "./LogonScreen"
import QuotePageApp from './QuotePageApp'

import {APIIsLoggedOn, APIloggedin, APICheckFlgID, APIGetSite, GetFlgFromID, APIAddUpdateSites} from './Api'

const cookies = new Cookies();

const getFLGID = () => {
    var query = window.location.search;
    var id = null
    query = query.replace(/\?/g,"{\"").replace(/\&/g,"\",\"").replace(/\=/g,"\":\"") + "\"}"
    var params = {}
    try{
        params = JSON.parse(query)
        id = parseInt(params.flg_id)

    }catch(e) {
        console.log('getFLGID')
        console.log(e)
    }

    // If no flg_id in URL, use default from environment for development
    if(!id || isNaN(id)) {
        const defaultFlgId = process.env.REACT_APP_DEFAULT_FLG_ID
        if(defaultFlgId) {
            id = parseInt(defaultFlgId)
            console.log(`Using default FLG ID from environment: ${id}`)
        }
    }

    return(id)
}

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            flg_id: -1,
            error: true,
            loggedon: false,
            token: '',
            user: '',
            userid: '',
            rep_email: '',
            rep_name: '',
            isvalid: true,
            flg_rec: null
        }
    }
    componentDidMount = async () => {
        try {
            var flg_id = getFLGID()
            //var flg_id = -1 // this.props.match.params.flg_id
            var loggedon = false
            var cookiedata, token, userid = null
            const error = flg_id ? false:true
            const flgcheck = await APICheckFlgID(flg_id)
            const isvalid = flgcheck ? flgcheck.status : false

            // See if we are logged on - First Get the cookie
            const loggedondata = await APIloggedin()
            var  flg_rec = await this.GetFlgData(flg_id,false)

            if(typeof loggedondata !== "undefined" && loggedondata.status)
                this.setState({flg_id,  isloading: false, ...loggedondata, isvalid, flg_rec: (flg_rec??null) })
            else
                this.setState({flg_id, token, loggedon: false , userid, error, isloading: false,isvalid, flg_rec: null})
        } catch (err) {
            console.error('Error during mount:', err)
            // Even if API fails, allow app to load with login screen
            var flg_id = getFLGID()
            this.setState({flg_id, token: null, loggedon: false, userid: null, error: false, isloading: false, isvalid: true, flg_rec: null})
        }
    }

    GetFlgData = async (flg_id, componentmounting) => {
      try {
        // Lets cvheck if we have a Site and if not we need to create a default one.
        const ret = await GetFlgFromID(flg_id)
        var flg_rec
        if(ret && ret.status && ret.payload.message === "OK")
            flg_rec = ret.payload

        let site = await APIGetSite(flg_id,0)

      if(!(site??null) && flg_rec) {

        let mobilephone = "";
        let homephone = "";
        let workphone = "";
        var phone1
        var phone2

        if(typeof flg_rec=="undefined" || typeof flg_rec.phone1 == "undefined")
            phone1 = ""
        else 
            phone1 = flg_rec.phone1.toString()

        if(typeof flg_rec=="undefined" || typeof flg_rec.phone2 == "undefined")
            phone2 = ""
        else 
            phone2 = flg_rec.phone2.toString()

        if(phone1.substr(0,1) == '7' )
            mobilephone = `0${phone1}`
        else if(phone1.substr(0,2) == '07' )
            mobilephone = `${phone1}`
        else if(phone1.substr(0,4) == '+447' )
            mobilephone = `${phone1}`
        else if(phone1.substr(0,5) == '+4407' )
            mobilephone = `${phone1}`
        if(mobilephone == "")
            homephone = phone1
        if(flg_rec.phone2 > '')
            workphone = phone2

        const newsite = {
          site_id: 0,
          primarycontact: 0,
          site_name: 'Main FLG Contact Site',
          address: {
            address1: flg_rec.address,
            address2: flg_rec.address2,
            address3: flg_rec.address3,
            town: flg_rec.towncity,
            county: '',
            postcode: flg_rec.postcode,
            country: '',
            aditionalnotes: 'Address taken from FLG original Customer record'
          },
          contacts: [{
            id: 0,
            title: flg_rec.title,
            first: flg_rec.firstname,
            last: flg_rec.lastname,
            email: flg_rec.email,
            mobilephone,
            workphone,
            homephone,
            notes: 'Contact auto created from FLG Record.'
          }]
        }
        await APIAddUpdateSites(flg_id,newsite)

      } 

      if(componentmounting)
        return flg_rec;

      this.setState({flg_rec})
      return flg_rec
      } catch (err) {
        console.error('Error getting FLG data:', err)
        return null
      }
    }

    UpdateStatus = async (props) => {
        const {loggedon, flg_id,user,token, userid, email} = props
        const cookiedata = {id: userid, token: token, rep_name: user, rep_email: email}
        // Set Token Cookie to expire in 4 hours = 14400 seconds
        cookies.set("wos_lo", JSON.stringify(cookiedata), { path: '/', maxAge: 14400 });
        await this.GetFlgData (flg_id,false)
        this.setState({loggedon, flg_id, user, token, rep_name: user, rep_email: email, userid, id: userid})
        return
    }

    UpdateUser = (event) => { this.setState({username: event.target.value}) }
    UpdatePassword = (event) => { this.setState({password: event.target.value}) }
 

    render() {
        const { classes } = this.props;
        const { loggedon,flg_id,error, isloading, rep_name, rep_email, isvalid} = this.state;
        if(!isvalid ) 
            return (
              <div style={{display: 'flex',  justifyContent:'center', alignItems:'center',  height: '100vh', fontSize: '32px', color: 'red'}} >
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                  The FLG Id {flg_id} is not Valid. Please ensure youu have a correct and Valid Id.
              </div>

            )


        if(isloading) 
            return(
                <Backdrop  open={isloading} className={classes.backdrop} >
                    <CircularProgress color="inherit" size={100}/>
                </Backdrop>
            )

        if(loggedon) {   
            // See if we have at least one Site for the current flg_id


            return (  <QuotePageApp props={this.props} flg_id={flg_id} rep_name={rep_name} rep_email={rep_email} />)
        }
        
        return(<LogonScreen flg_id={flg_id} onChange={this.UpdateStatus} />)
    }
    
}

const styles = theme => ({
    root: {
        width: '50%',
        backgroundColor: 'white',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 5,
    }, 
    backdrop: {
        backgroundColor: 'white'
    }
});

 export default withStyles(styles)(App);
